const TERMINAL = new Set(["DONE", "FAILED", "CANCELLED"]);

/** 잡 상태 폴러. 실제 setInterval 사용(테스트는 fake timers). start()는 즉시 1회 tick 후 interval. */
export function createJobPoller({
  jobId,
  getJob,
  onUpdate,
  onDone,
  intervalMs = 2000,
  maxMs = 600000,
}) {
  let id = null;
  let startedAt = 0;
  async function tick() {
    if (Date.now() - startedAt > maxMs) {
      stop();
      onDone && onDone({ status: "TIMEOUT" });
      return;
    }
    try {
      const job = await getJob(jobId);
      onUpdate && onUpdate(job);
      if (job && TERMINAL.has(job.status)) {
        stop();
        onDone && onDone(job);
      }
    } catch (e) {
      // 일시적 네트워크/락 — 다음 tick 에서 재시도
    }
  }
  function start() {
    if (id != null) return;
    startedAt = Date.now();
    id = setInterval(tick, intervalMs);
    tick();
  }
  function stop() {
    if (id != null) {
      clearInterval(id);
      id = null;
    }
  }
  return { start, stop };
}
